import { FadeUp, MaskReveal } from "@/components/Reveal";
import { ArrowButton } from "@/components/ArrowButton";
import { PROFESSIONAL } from "@/data/site";

const SobreTeaser = () => (
  <section data-testid="sobre-teaser-section" className="border-t border-raiz-900/10 py-20 lg:py-28">
    <div className="container-x grid items-center gap-14 lg:grid-cols-12">
      <div className="relative order-2 lg:order-1 lg:col-span-5">
        <div aria-hidden="true" className="absolute -bottom-6 -left-6 h-full w-full rounded-[2rem] bg-sand" />
        <MaskReveal className="relative overflow-hidden rounded-[2rem]">
          <img
            src="/assets/sabrina-sobre.jpg"
            alt="Sabrina Mota, psicóloga e neuropsicóloga, de jaleco branco"
            data-testid="sobre-teaser-photo"
            loading="lazy"
            className="aspect-[4/5] w-full object-cover"
            width="1200"
            height="1500"
          />
        </MaskReveal>
      </div>
      <div className="order-1 lg:order-2 lg:col-span-7 lg:pl-8">
        <FadeUp>
          <p className="eyebrow" data-testid="sobre-teaser-eyebrow">05 — Sobre</p>
        </FadeUp>
        <FadeUp delay={0.08}>
          <h2 className="mt-5 font-serif text-3xl font-light leading-[1.12] tracking-tight text-ink sm:text-4xl lg:text-5xl" data-testid="sobre-teaser-title">
            Prazer, sou <em className="italic text-raiz-700">Sabrina Mota.</em>
          </h2>
        </FadeUp>
        <FadeUp delay={0.16}>
          <p className="lead mt-7 max-w-xl">
            Sou psicóloga e neuropsicóloga, formada em Psicologia em 2023, com trajetória na prática clínica iniciada ainda durante a graduação, em 2021.
          </p>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-ink/70">
            Atendo crianças, adolescentes e adultos e também realizo avaliações e reavaliações neuropsicológicas. Meu trabalho parte de um olhar individualizado: compreender cada pessoa considerando sua história, seu contexto, suas dificuldades e também suas potencialidades.
          </p>
          <p className="mt-5 max-w-xl font-serif text-lg italic text-raiz-800">
            Acredito que compreender também é uma forma de transformar.
          </p>
        </FadeUp>
        <FadeUp delay={0.24} className="mt-8 border-l-2 border-gold-500/70 pl-5">
          <p className="font-serif text-lg text-raiz-900">{PROFESSIONAL.name}</p>
          <p className="text-sm text-ink/60">{PROFESSIONAL.titles} — {PROFESSIONAL.crp}</p>
        </FadeUp>
        <FadeUp delay={0.3} className="mt-9">
          <ArrowButton to="/sobre" variant="outline" testId="sobre-teaser-cta-button">
            Conhecer minha trajetória
          </ArrowButton>
        </FadeUp>
      </div>
    </div>
  </section>
);

export default SobreTeaser;
